// extracted by mini-css-extract-plugin
export default {"modal":"yL-z","modalOverlay":"zL-z","outfitHeading":"AL-z"};